export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        transition: 'all 0.3s ease-in-out',
    },
    heading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        '& .MuiSvgIcon-root': {
            position: 'absolute',
            left: 0,
        },
        '& > div': {
            paddingLeft: '32px',
            paddingRight: '32px',
        },
    },
    iconCompleted: {
        color: 'rgb(145, 85, 253)',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '32px',
        width: '100%',
        margin: '0 auto 2rem',
    },
    inputsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
    },
    validationError: {
        position: 'absolute',
    },
};
